<template>
  <div class="brochure-selection">
    <p class="brochure-selection__introduction">You have {{brochureCount}} selected brochure(s):</p>
    <ul class="brochure-selection__list">
      <li
        class="brochure-selection__list-item"
        v-for="brochure in brochureSelection"
        :key="brochure.code"
      >
        <BrochureSelectionItem :brochure="brochure" :brandName="brandName"/>
      </li>
    </ul>
    <button class="brochure-selection__list-link link" @click="changeState" aria-label="Change your selection" title="Click to change your selection">Change selection</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BrochureSelectionItem from './BrochureSelectionItem.vue';

export default {
  components: {
    BrochureSelectionItem
  },

  props: ['brandName'],

  computed: mapGetters('brochureRequest', [
    'brochureCount',
    'brochureSelection'
  ]),

  methods: {
    changeState() {
      this.$store.commit('brochureRequest/changeState');
      window.scroll(0, 0);
    }
  }
};
</script>